const ACCESS_LINK_RECIPIENT_KEY = "kovaad_access_link_recipient";
export const ACCESS_LINK_RECIPIENT_TTL_MS = 30 * 60 * 1000;

type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function defaultStorage(): StorageLike | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

const normalizeEmail = (email?: string | null): string =>
  (email ?? "").trim().toLowerCase();

export function isSameEmail(a?: string | null, b?: string | null): boolean {
  const left = normalizeEmail(a);
  return !!left && left === normalizeEmail(b);
}

export function decideAccessLinkAction(params: {
  recipient: string;
  loggedInEmail?: string | null;
}): "continue" | "relogin" {
  return isSameEmail(params.loggedInEmail, params.recipient)
    ? "continue"
    : "relogin";
}

export function stashAccessLinkRecipient(
  email: string,
  nowMs: number = Date.now(),
  storage: StorageLike | null = defaultStorage(),
): void {
  try {
    storage?.setItem(
      ACCESS_LINK_RECIPIENT_KEY,
      JSON.stringify({
        email: normalizeEmail(email),
        exp: nowMs + ACCESS_LINK_RECIPIENT_TTL_MS,
      }),
    );
  } catch {
    // ignore quota / private mode
  }
}

export function readAccessLinkRecipient(
  nowMs: number = Date.now(),
  storage: StorageLike | null = defaultStorage(),
): string | null {
  try {
    const raw = storage?.getItem(ACCESS_LINK_RECIPIENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.email !== "string" || typeof parsed?.exp !== "number") {
      return null;
    }
    return parsed.exp >= nowMs ? parsed.email : null;
  } catch {
    return null;
  }
}

export function clearAccessLinkRecipient(
  storage: StorageLike | null = defaultStorage(),
): void {
  try {
    storage?.removeItem(ACCESS_LINK_RECIPIENT_KEY);
  } catch {
    // ignore
  }
}

export function getAccessLinkMismatchMessage(recipient: string): string {
  return `This link was sent to ${recipient}. Please sign in with that account.`;
}
